import React, { useState, useEffect } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import {
  RadioGroup,
  RadioGroupChangeEvent,
} from "@progress/kendo-react-inputs";
import { Input } from "@progress/kendo-react-inputs";
import {
  Form,
  Field,
  FormElement,
  FieldRenderProps,
  FormRenderProps,
  FieldWrapper,
} from "@progress/kendo-react-form";
import { useSelector } from "react-redux";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { useAppDispatch } from "../Core/store.hooks";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import Spinner from "../Common/Components/spinner";
import { SupportCasesApi } from "./api";
import { CustomersApi } from "../Customers/api";
import AddSupportCaseForm from "./AddSupportCaseForm";
import ErrorMessage from "../Common/Components/ErrorMessage";
import cookies from "../Common/Util_methods/cookies";

type handler = () => void;
interface addSupportCaseProps {
  visible: boolean;
  toggleVisible: handler;
  machine: String;
  customerId: String;
  types: any;
}

const AddSupportCaseDialog = (props: addSupportCaseProps) => {
  const [selected, setSelected] = useState(0);
  const [machine, updateMachine] = useState(null);
  const [jiraData, updateJiraData] = useState(null);
  const [jiraLoading, updateJiraLoading] = useState(false);
  const [serialList, updateSerialList] = useState(null);
  const [serialListLoading, updateLoadingSerialList] = useState(true);
  const [selectedSerial, updateSelectedSerial] = useState(null);
  const [jiraUsers, updateUserList] = useState(null);
  const [loadingUserList, updateLoadingUserList] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [stage, updateStage] = useState(1);
  const [customerInfo, updateCustomerInfo] = useState(null);
  const [customerInfoLoading, updateCustomerInfoLoading] = useState(false);
  const [initialValues, updateInitialValues] = useState(null);
  const [selectedType, updateSelectedType] = useState(null);
  const [user, updateUser] = useState(null);
  const [machineInfo, updateMachineInfo] = useState(null);
  const [machineInfoLoading, updateMachineInfoLoading] = useState(false);

  function getCookie(cookieName) {
    let cookie = {};
    document.cookie.split(";").forEach(function (el) {
      let [key, value] = el.split("=");
      cookie[key.trim()] = value;
    });
    return cookie[cookieName];
  }

  useEffect(() => {
    const userCookie = cookies.get("fleet-name");
    let userName = userCookie;

    //if (userCookie != undefined) {
    //  const nameArray = userCookie.split(".");
    //  userName =
    //    nameArray[0].charAt(0).toUpperCase() +
    //    nameArray[0].slice(1) +
    //    " " +
    //    nameArray[1].charAt(0).toUpperCase() +
    //    nameArray[1].slice(1);
    //}
    userCookie != undefined ? updateUser(userName) : updateUser("undefined");
    getJiraUserList();
  }, []);

  useEffect(() => {
    if (props.types != null) {
      updateSelectedType(props.types[0]);
    }
  }, [props.types]);
    useEffect(() => {
        if (serialList != null) {
            updateSelectedSerial(serialList[0].value)
        }
    },[serialList])
  

  useEffect(() => {
    updateJiraData(null);
    if (machine != null) {
      fetchJiraMetaData();
    }
  }, [machine]);

  useEffect(() => {
    updateMachine(machine);
  }, [props.machine]);

    useEffect(() => {
     // console.log(props)
      if (props.machine != null) {
          fetchSerials();
      }
      else { continueHandler() }
    GetCustomerInfo();
  }, [props.machine, props.customerId]);

  useEffect(() => {
    if (customerInfo != null && jiraData != null && jiraUsers != null) {
      if (props.machine == null || machineInfo != null) {
        let newInitialValues: any = {};

        newInitialValues.customfield_11820 = customerInfo.customerID;
        newInitialValues.customfield_10823 = customerInfo.customerName;
        if (machineInfo != null) {
          if (machineInfo.customfield_11646 != undefined) {
            newInitialValues.customfield_11646 = machineInfo.customfield_11646;
          }

          if (machineInfo.customfield_11645 != undefined) {
            newInitialValues.customfield_11645 = machineInfo.customfield_11645;
          }

          if (machineInfo.customfield_11647 != undefined) {
            newInitialValues.customfield_11647 = machineInfo.customfield_11647;
          }

          if (machineInfo.customfield_10070 != undefined) {
            newInitialValues.customfield_10070 = machineInfo.customfield_10070;
          }
            newInitialValues.customfield_16524 = machineInfo.customfield_16524;
        }
        let defaultCountryItem = null;
        if (jiraData.customfield_11926 != null) {
          if (customerInfo.country == "United States") {
            for (
              var i = 0;
              i < jiraData.customfield_11926.allowedValues.length;
              i++
            ) {
              if (jiraData.customfield_11926.allowedValues[i].value == "USA") {
                defaultCountryItem =
                  jiraData.customfield_11926.allowedValues[i];
                break;
              }
            }
          }
            else if (customerInfo.country == "Korea") {
                for (
                    var i = 0;
                    i < jiraData.customfield_11926.allowedValues.length;
                    i++
                ) {
                    if (jiraData.customfield_11926.allowedValues[i].value == "South Korea") {
                        defaultCountryItem =
                            jiraData.customfield_11926.allowedValues[i];
                        break;
                    }
                }
            }


          else {
          //    console.log(customerInfo.country, jiraData.customfield_11926.allowedValues)
            for (
              var i = 0;
              i < jiraData.customfield_11926.allowedValues.length;
              i++
            ) {
              if (
                jiraData.customfield_11926.allowedValues[i].value ==
                customerInfo.country
              ) {
                defaultCountryItem =
                  jiraData.customfield_11926.allowedValues[i];
                break;
              }
            }
          }
          newInitialValues.customfield_11926 = defaultCountryItem;
        }

        if (user != undefined && user != "undefined") {
          for (var i = 0; i < jiraUsers.length; i++) {
            if (user == jiraUsers[i].displayName) {
             // newInitialValues.assignee = jiraUsers[i];
              newInitialValues.reporter = jiraUsers[i];
              break;
            }
          }
        }
        //for (var i = 0; i < jiraData.priority.allowedValues.length; i++) {
        //  if (jiraData.priority.allowedValues[i].id == "3") {
        //    newInitialValues.priority = jiraData.priority.allowedValues[i];
        //    break;
        //  }
        //}
        //if (jiraData.customfield_12020 != undefined) {
        //  newInitialValues.customfield_12020 =
        //    jiraData.customfield_12020.defaultValue;
        //}
        updateInitialValues(newInitialValues);
      }
    }
  }, [customerInfo, jiraData, jiraUsers, machineInfo]);

  const handleSelect = (e: any) => {
    setSelected(e.selected);
  };

    const continueHandler = () => {
     // console.log(props)
    if (props.machine != null) {
    
        if (selectedSerial != null) {
          fetchMachineInfo(selectedSerial);
          updateStage(2);
        } else {
          if (serialList.length > 0) {
            fetchMachineInfo(serialList[0].value);
            updateStage(2);
          }
        }
      
    } else {
      updateStage(2);
    }
    fetchJiraMetaData();
  };

  const GetCustomerInfo = () => {
    updateCustomerInfoLoading(true);
    setErrorMessage(null);
    CustomersApi.getCustomerInfo({ customerId: props.customerId })
      .then((response: any) => {
        updateCustomerInfo(response);
        setErrorMessage(null);

        updateCustomerInfoLoading(false);
      })
      .catch((error) => {
        updateCustomerInfoLoading(false);
        if (error.message != "canceled") {
          setErrorMessage("Oops something went wrong, unable to get data.");
        }
      });
  };
  const getJiraUserList = () => {
    updateLoadingUserList(true);
    SupportCasesApi.getUserList()
      .then((response: any) => {
        updateUserList(response);
        updateLoadingUserList(false);

        setErrorMessage(null);
      })
      .catch((error) => {
        updateLoadingUserList(false);
        setErrorMessage("Oops something went wrong, unable to get data.");

        console.log(error);
      });
  };

  const fetchSerials = () => {
    let params: any = { machineSerial: props.machine };
    SupportCasesApi.getSerialsByMachine(params)
      .then((response: any) => {
        const newSerialList: any = [];
        for (var i = 0; i < response.length; i++) {
          let obj: any = {};
          obj.label = response[i];
          obj.value = response[i];
          newSerialList.push(obj);
        }
        updateSerialList(newSerialList);
        updateLoadingSerialList(false);

        setErrorMessage(null);
      })
      .catch((error) => {
        updateLoadingSerialList(false);
        setErrorMessage("Oops something went wrong, unable to get data.");

        console.log(error);
      });
  };
  const fetchJiraMetaData = () => {
    updateJiraLoading(true);
      let params: any = { project: "GSPUP", typeName: "13851" };
    SupportCasesApi.getIssueMetaData(params)
        .then((response: any) => {
            response.projects[0].issuetypes[0].fields.reporter = {}
        updateJiraData(response.projects[0].issuetypes[0].fields);

        setErrorMessage(null);
        updateJiraLoading(false);
      })
      .catch((error) => {
        setErrorMessage("Oops something went wrong, unable to get data.");

        console.log(error);
        updateJiraLoading(false);
      });
  };
  const fetchMachineInfo = (_serial: string) => {
    updateMachineInfoLoading(true);
    let params: any = {
      deviceSerial: _serial,
      machineSerial: props.machine,
      customerID: props.customerId,
    };
    SupportCasesApi.getIssueMachineData(params)
      .then((result: any) => {
        let newMachineInfo: any = {};
        if (result.cncType.length > 1) {
          newMachineInfo.customfield_11646 = result.cncType;
        }

        if (result.cncMan.length > 1) {
          newMachineInfo.customfield_11645 = result.cncMan;
        }

        if (result.machineType.length > 1) {
          newMachineInfo.customfield_11647 = result.machineType;
        }

        if (result.project.length > 1) {
          newMachineInfo.customfield_10070 = result.project;
        }
          newMachineInfo.customfield_16524 = _serial;

        updateMachineInfo(newMachineInfo);

        setErrorMessage(null);
        updateMachineInfoLoading(false);
      })
      .catch((error) => {
        setErrorMessage("Oops something went wrong, unable to get data.");

        console.log(error);
        updateMachineInfoLoading(false);
      });
  };
  const toggleVisible = () => {
    resetDialog();
    props.toggleVisible();
  };
  const resetDialog = () => {
    updateStage(1);
    updateJiraData(null);
    setErrorMessage(null);
  };

  const serialListHandler = (e: any) => {
    updateSelectedSerial(e.value);
  };

  const renderMachineList = () => {
    if (serialList == null) {
      return <Spinner text="serial list" />;
    }
      if (serialList.length == 0) return <div>No Serial found</div>;
   
     // console.log(serialList)
    return (
      <div style={{ display: "inline-block", marginLeft: "20px" }}>
        <div style={{ fontWeight: "bold" }}>Select Serial:</div>
        <RadioGroup
                data={serialList}

                value={selectedSerial} 
          onChange={serialListHandler}
        />
      </div>
    );
  };
  const typeHandler = (e: any) => {
    for (var i = 0; i < props.types.length; i++) {
      if (props.types[i].name == e.value) {
        updateSelectedType(props.types[i]);
      }
    }
  };
  const renderTypes = () => {
    if (props.types == null) return "Loading types...";
    const names: any = [];
    for (var i = 0; i < props.types.length; i++) {
      names.push({ label: props.types[i].name, value: props.types[i].name });
    }
    return (
      <div style={{ display: "inline-block", marginLeft: "20px" }}>
        <div style={{ fontWeight: "bold" }}>Select Type:</div>
        <RadioGroup
          data={names}
          defaultValue={names[0].value}
          onChange={typeHandler}
        />
      </div>
    );
  };

  const renderContent = () => {
    if (errorMessage != null) {
      return (
        <>
          <p>{errorMessage}</p>
        </>
      );
    }
    if (stage == 1) {
      if (machine == null && serialList == null) {
        return <Spinner text="machine serial list" />;
      }

      if (serialList != null && machine == null) {
        return renderMachineList();
      }
    } else {
      if (
        jiraLoading ||
        customerInfoLoading ||
        initialValues == null ||
        loadingUserList ||
        machineInfoLoading
      ) {
        return <Spinner text="data" />;
      }

      //add check for if customerinfo or jiradata is loading
      return (
        <AddSupportCaseForm
          initialValues={initialValues}
          jiraData={jiraData}
          user={user}
          jiraUsers={jiraUsers}
          type={selectedType}
        />
      );
    }
  };
  const renderContinueButton = () => {
    if (stage != 2) {
      return (
        <button
          className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
          onClick={continueHandler}
        >
          Continue
        </button>
      );
    }
  };
  const renderDialog = () => {
    if (props.visible) {
      return (
        <div className="supportCaseDialog">
          <Dialog
            title={"Add Support Case"}
            onClose={toggleVisible}
            width={1000}
          >
            <div style={{ backgroundColor: "#fff", padding: "0px" }}>
              {renderContent()}
            </div>
            <DialogActionsBar>
              <button
                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                onClick={toggleVisible}
              >
                Close
              </button>
              {renderContinueButton()}
            </DialogActionsBar>
          </Dialog>
        </div>
      );
    }
    return null;
  };

  return renderDialog();
};

export default AddSupportCaseDialog;
